// src/admin/components/Avatar.tsx — deterministic-colour initials avatar.
// Background colour is picked from a small Cobalt-friendly palette using a
// stable hash of the name, so the same person gets the same colour everywhere.
import styles from './Avatar.module.css';

const PALETTE = ['#1260B0', '#0891B2', '#7C3AED', '#0D9488', '#B45309', '#15803D'];

function colourFor(name: string): string {
  let h = 0;
  for (let i = 0; i < name.length; i++) h = (h + name.charCodeAt(i)) | 0;
  return PALETTE[Math.abs(h) % PALETTE.length] ?? PALETTE[0]!;
}

export default function Avatar({
  name,
  size = 32,
}: { name: string | null | undefined; size?: number }) {
  const safe = name ?? '?';
  const initials = safe.split(/\s+/).slice(0, 2).map(s => s[0]?.toUpperCase() ?? '').join('') || '?';
  return (
    <span
      className={styles.a}
      style={{
        width: size,
        height: size,
        fontSize: size * 0.38,
        background: colourFor(safe),
      }}
    >
      {initials}
    </span>
  );
}
